/* eslint-disable max-len */
import * as React from 'react';

const Volume = (props) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.098 11.9122C27.4159 11.5845 27.9313 11.5846 28.2492 11.9124C30.4366 14.1681 31.6654 17.227 31.6654 20.4165C31.6654 23.606 30.4366 26.665 28.2492 28.9206C27.9313 29.2484 27.4159 29.2485 27.098 28.9208C26.78 28.5931 26.7799 28.0618 27.0978 27.734C28.98 25.7931 30.0373 23.161 30.0373 20.4165C30.0373 17.672 28.98 15.0399 27.0978 13.099C26.7799 12.7712 26.78 12.2399 27.098 11.9122ZM19.2671 11.8277C19.5491 11.9674 19.7285 12.2614 19.7285 12.584V28.249C19.7285 28.5716 19.5491 28.8656 19.2671 29.0054C18.9851 29.1451 18.6503 29.1058 18.406 28.9043L13.202 24.6125H9.14607C8.69649 24.6125 8.33203 24.2368 8.33203 23.7733V17.0597C8.33203 16.5963 8.69649 16.2205 9.14607 16.2205H13.202L18.406 11.9287C18.6503 11.7272 18.9851 11.6879 19.2671 11.8277ZM18.1004 14.3301L13.9961 17.715C13.8518 17.8341 13.6724 17.8989 13.4876 17.8989H9.9601V22.9341H13.4876C13.6724 22.9341 13.8518 22.9989 13.9961 23.118L18.1004 26.5029V14.3301ZM23.2666 15.862C23.5845 15.5343 24.0999 15.5344 24.4178 15.8622C25.5878 17.0687 26.2451 18.7049 26.2451 20.4109C26.2451 22.1169 25.5878 23.7531 24.4178 24.9596C24.0999 25.2874 23.5845 25.2875 23.2666 24.9598C22.9486 24.6321 22.9486 24.1008 23.2664 23.773C24.1312 22.8812 24.617 21.6719 24.617 20.4109C24.617 19.1499 24.1312 17.9406 23.2664 17.0488C22.9486 16.721 22.9486 16.1897 23.2666 15.862Z"
      fill="#121212"
    />
  </svg>
);
export default Volume;
